import { Component } from 'react'
import { Button, Container, Icon, Message } from 'semantic-ui-react'
import Error from '@view/components/Error'

const devMode = process.env.NODE_ENV === 'development'
export const prodErrorContent =
	'If you’re sure you have the right URL, try refreshing the page after a few seconds. If the problem persists, please contact customer support.'

class ErrorBoundary extends Component {
	state = { hasError: false, errorInfo: '' }

	static getDerivedStateFromError(error) {
		return { hasError: true }
	}

	componentDidCatch(error, info) {
		this.setState({ errorInfo: `${error.toString()}${info.componentStack}` })
	}

	render() {
		if (this.state.hasError)
			return <Error themeColour={this.props.themeColour} errorContent={devMode ? this.state.errorInfo : prodErrorContent} />

		return this.props.children
	}
}

export default ErrorBoundary
